import { render } from "./OJ1013F.vue?vue&type=template&id=0d751bba&ts=true"
import script from "./OJ1013F.vue?vue&type=script&lang=ts"
export * from "./OJ1013F.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\開発\\PSAP\\おくやみシステム\\OJ0000P_Vue\\OJ0000P\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__